import React from 'react';
import PropTypes from 'prop-types';

const ICONS = {
    'default': {
        'up': 'fa-long-arrow-up',
        'down': 'fa-long-arrow-down',
    },
    'alternate': {
        'up': 'fa-caret-up',
        'down': 'fa-caret-down',
    },
};

const propTypes = {
    className: PropTypes.string,
    asc: PropTypes.bool,
    iconType: PropTypes.oneOf(Object.keys(ICONS)),
};

const defaultProps = {
    className: '',
    asc: false,
    iconType: 'default',
};

function TableHeaderSortIcon({ className, asc, iconType }) {
    return <span className={ !!asc ? `fa ${ICONS[iconType].up} ${className}` : `fa ${ICONS[iconType].down} ${className}`} aria-hidden="true" />;
}

TableHeaderSortIcon.propTypes = propTypes;
TableHeaderSortIcon.defaultProps = defaultProps;

export default TableHeaderSortIcon;